import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Public account statement via signed link — same HTML as PDF (server-rendered).
 */
export default function PublicStatementView() {
  const { token } = useParams();

  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    const slug = sp.get('portalSlug')?.trim() || sp.get('slug')?.trim() || '';
    let htmlUrl = `/api/portal/statement/${token}/html`;
    if (slug) {
      htmlUrl += `?portalSlug=${encodeURIComponent(slug)}`;
    }
    window.location.href = htmlUrl;
  }, [token]);

  return (
    <div className="min-h-screen bg-[var(--ds-canvas-bg)] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--ds-accent-primary)]" />
        <p className="mt-2 text-meta text-[var(--ds-text-muted)]">Loading statement…</p>
      </div>
    </div>
  );
}
